import { useMemo, useRef } from "react";

import { useNavigate } from "@tanstack/react-router";

import { listSoftwareMetadata } from "@synthesis/shared-services/reporting/reportGenerationModelsController/client";
import { IconArrowLeft, IconDownload } from "@synthesis/shared-icons";
import { Button, Table } from "@synthesis/shared-ui";
import { logger } from "@synthesis/shared-utils";

import { useDownloadModelSoftwareReport } from "../../../../entity/reporting";
import { AccessDenied } from "../../../components/access-denied";
import { useUserRolesGGE } from "../../../hooks";

import { defaultColDef, tableColumnsStatisticsUsageSoftware } from "../reports.lib";

export const StatisticsUsageSoftwarePage = () => {
  const navigate = useNavigate();
  const roles = useUserRolesGGE();
  const gridApi = useRef<unknown>(null);
  const { mutate: downloadReport } = useDownloadModelSoftwareReport();

  const serverSideDatasource = useMemo(
    () => ({
      getRows: async (params: { success: (value: { rowData: unknown[]; rowCount: number; rowCountKnown: boolean }) => void; fail: () => void }) => {
        try {
          const data = (await listSoftwareMetadata({})).data;
          const rowData = data.map((project) => ({
            modelCount: Number(project?.modelCount ?? 0),
            softwareName: project?.softwareName ?? "",
            softwareVersion: project?.softwareVersion ?? "",
          }));
          const totalFiles = rowData.reduce((sum, row) => sum + row.modelCount, 0);
          const rowsWithTotal = [...rowData, { total: "Итого", modelCount: totalFiles, isTotal: true }];
          params.success({ rowData: rowsWithTotal, rowCount: rowsWithTotal.length, rowCountKnown: true });
        } catch (error) {
          logger.error("Error fetching statistics usage software:", error);
          params.fail();
        }
      },
    }),
    [],
  );

  const onGridReady = (params: { api: unknown }) => {
    gridApi.current = params.api;
  };

  if (roles.МОДЕРИРОВАНИЕ || roles.ПРОСМОТР || roles.НЕТ) {
    return <AccessDenied />;
  }

  return (
    <main className="relative flex h-full flex-col">
      <h1 className="heading-h4 flex flex-col gap-4 rounded-xl px-8 pb-6 pt-8">Отчёты</h1>
      <div className="mx-8 mb-8 flex min-h-0 flex-1 flex-col gap-4 rounded-2xl bg-white px-6 py-8">
        <Button className="w-fit" theme="text" leftIcon={<IconArrowLeft className="size-5" />} onClick={() => navigate({ to: "/reports" })}>
          Назад
        </Button>
        <h4 className="heading-h4">Статистика по использованию ПО</h4>
        <Button size="sm" className="ml-auto" leftIcon={<IconDownload className="size-5" />} onClick={() => downloadReport()}>
          Экспортировать отчёт в .xlsx
        </Button>
        <div className="min-h-0 flex-1">
          <Table
            tableId="StatisticsUsageSoftware"
            isSortable
            hasFilters={false}
            tableColumns={tableColumnsStatisticsUsageSoftware(navigate)}
            defaultColDef={defaultColDef}
            rowModelType="serverSide"
            serverSideDatasource={serverSideDatasource}
            onGridReady={onGridReady}
            module="gge"
          />
        </div>
      </div>
    </main>
  );
};
